module.exports = __webpack_public_path__ + "static/media/bg-our-food-dt.405e9cdf.jpg";